import {
  CHANGE_PAGE_SIZE,
  CHANGE_SORTING,
  CHANGE_VIEW_TYPE,
  SET_IS_COMPARISON_BAR_CLOSED,
  UPDATE_PRODUCTS_COMPARE_SETTINGS,
} from 'b2b-apps/shop/settings/redux/actionTypes';
import {
  ChangePageSizeAction,
  ChangeSortingAction,
  ChangeViewTypeAction,
  PageSizeSettingType,
  SetIsComparisonBarClosedAction,
  SettingsProductsCompareType,
  SortingSettingType,
  UpdateProductsCompareSettingsAction,
  ViewTypeSettingType,
} from 'b2b-apps/shop/settings/redux/types';

const changePageSize = (
  pageSize: PageSizeSettingType,
): ChangePageSizeAction => ({
  type: CHANGE_PAGE_SIZE,
  payload: {
    pageSize,
  },
});

const changeSorting = (sorting: SortingSettingType): ChangeSortingAction => ({
  type: CHANGE_SORTING,
  payload: {
    sorting,
  },
});

const changeViewType = (
  viewType: ViewTypeSettingType,
): ChangeViewTypeAction => ({
  type: CHANGE_VIEW_TYPE,
  payload: {
    viewType,
  },
});

const updateProductsCompareSettings = (
  productsCompare: Partial<SettingsProductsCompareType>,
): UpdateProductsCompareSettingsAction => ({
  type: UPDATE_PRODUCTS_COMPARE_SETTINGS,
  payload: {
    productsCompare,
  },
});

const setIsComparisonBarClosed = (
  isClosed: boolean,
): SetIsComparisonBarClosedAction => ({
  type: SET_IS_COMPARISON_BAR_CLOSED,
  payload: {
    isClosed,
  },
});

export {
  changePageSize,
  changeSorting,
  changeViewType,
  setIsComparisonBarClosed,
  updateProductsCompareSettings,
};
